import { Component, Input, OnDestroy } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Subscription, from } from 'rxjs';
import { MeetingSchedulerStoreService } from '../../data-providers/meeting-scheduler-store.service';
import { DurationOption } from '../duration-multi-select/duration-multi-select.component';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { POSTHOG_ACTIONS, POSTHOG_CATEGORIES, POSTHOG_KEYS } from '../../constants';

@Component({
  selector: 'meeting-scheduler-settings-notice-time-card',
  templateUrl: './notice-time-card.component.html',
  styleUrls: ['./notice-time-card.component.scss'],
  standalone: false,
})
export class NoticeTimeCardComponent implements OnDestroy {
  @Input() noticeTime: number;
  @Input() enableTracking: boolean;

  hourTime = 3600;
  options: DurationOption[] = [
    { seconds: 0, label: '0' },
    { seconds: this.hourTime, label: `1` },
    { seconds: this.hourTime * 2, label: `2` },
    { seconds: this.hourTime * 4, label: `4` },
    { seconds: this.hourTime * 12, label: `12` },
    { seconds: this.hourTime * 24, label: `24` },
    { seconds: this.hourTime * 48, label: `48` },
  ];

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly meetingSchedulerService: MeetingSchedulerStoreService,
    private readonly alertService: SnackbarService,
    private readonly analyticsService: ProductAnalyticsService,
  ) {}

  onDurationSelected(option: DurationOption): void {
    this.subscriptions.push(
      from(this.meetingSchedulerService.updateUserPreferences({ noticeTime: option.seconds })).subscribe({
        next: () => {
          if (this.enableTracking) {
            this.analyticsService.trackEvent(
              POSTHOG_KEYS.HOST_PREFERENCE_UPDATED,
              POSTHOG_CATEGORIES.USER,
              POSTHOG_ACTIONS.CLICK,
            );
          }
          this.alertService.openSuccessSnack('MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.ALERTS.NOTICE_TIME.SUCCESS');
        },
        error: () =>
          this.alertService.openErrorSnack('MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.ALERTS.NOTICE_TIME.ERROR'),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
